const hostname = window.location.hostname;
console.log('hostname', hostname);
const protocoltxt = 'https:';//window.location.protocol;

//zenbu.jankosoftworks.com
var domainValues = {
					        //"zenbu.jankosoftworks.com": {

					      "order.chefsgallery.com.au" : {
					       // "172.20.10.3":{
							apiUrl: protocoltxt+'//mars.ninjaos.com/api/', //'https://ccpl.ninjaos.com/api/',
							apiUrlPro: protocoltxt+'//mars.ninjaos.com/ninjapro/', //'https://ccpl.ninjaos.com/ninjapro/',
							apiUrlv2 :  protocoltxt+"//mars.ninjaos.com/apiv2/",
							tinThumpUrl: protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',
							//appId:"C52E8EE5-05AB-4029-9C6E-ECD2F5323404",
							//appId:"60A81B14-07D2-4E09-8255-60746D0C242A",
							appId : "98E127B4-44B9-4B5C-8D17-D35258E10DE3",
							fbAppId:"834478453372307",
							logo : "/img/ninjaprocmn/logo.png",
							chatWidget : "JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",
							stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",
							stripeCompany: "Chefs Gallery",
							stripeImage:"https://order.chefsgallery.com.au/img/ninjaprocmn/chefsgallery/stripe_logo.png",
							stripeEmail: 'vignesh@jankosoft.com',
							stripeReference: "chefsgallery",
							stripeDesc: 'My Checkout',
							stripeCurrency: 'AUD',
							defaultAvilablityId : '634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',
							defaultAvilablityName : 'Delivery',
							defaultAvilablityImage : '/img/icons/Delivery_white.png',
							baseUrl: 'https://order.chefsgallery.com.au/#/',
							product_thumbnail : "/img/no-images/productthump-no-image.jpg",
							product_listing : "/img/no-images/products-no-image.jpg",
							fb: {
								fbURL: 'https://order.chefsgallery.com.au/#/',
								fbImage: 'https://order.chefsgallery.com.au/img/chefsgallery/logo.png',
								fbTitle: "Chefs Gallery",
								fbDesc: 'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.chefsgallery.com.au/',
							   },
							   /* Twitter  */
							   tw: {
								twURL: 'https://order.chefsgallery.com.au/#/',
								twTitile: "Chefs Gallery",
								twvia: "Chefs Gallery",
							   },
							   
								 /* google Plus data   */
							   gp: {
								gpURL: 'https://order.chefsgallery.com.au/#/',
						 
							   },
							   
								   /* Whatsapp data   */
							   wa: {
								waURL: 'https://order.chefsgallery.com.au/#/',
								waSeparator : 'Chefs Gallery',
						 
							   },
							   site_title: "Chefs Gallery",
							   site_title_with_separator: " | Chefs Gallery",
							   home_meta_title:"Welcome to Chefs Gallery",
							   bgimage: '/img/ninjaprocmn/chefsgallery/body_bg.jpg'
					}
					
					
					
					
			}; 


/* get current host name */

const getAppValues = {
/* all path values */
path: {
baseUrl:domainValues[hostname].baseUrl,
apiUrl:domainValues[hostname].apiUrl, //'https://ccpl.ninjaos.com/api/',
apiUrlPro:domainValues[hostname].apiUrlPro, //'https://ccpl.ninjaos.com/ninjapro/',
apiUrlv2:domainValues[hostname].apiUrlv2,
apiUrlNotify:protocoltxt+'//mars.ninjaos.com/',
tinThumpUrl:domainValues[hostname].tinThumpUrl,
logo : domainValues[hostname].logo, 
},ids:{  
appId:  domainValues[hostname].appId,            
deliveryId : '634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',
pickupId: '718B1A92-5EBB-4F25-B24D-3067606F67F0',
dineinId: 'EF9FB350-4FD4-4894-9381-3E859AB74019',
reservationId: '79FA4C7F-75A1-4A95-B7CE-81ECA2575363',
currency: 'AUD',
defaultAvilablityId : domainValues[hostname].defaultAvilablityId,
defaultAvilablityName : domainValues[hostname].defaultAvilablityName,
defaultAvilablityImage : domainValues[hostname].defaultAvilablityImage,
fbAppId : domainValues[hostname].fbAppId  //'104121986790084' demo - 410091149364782
},stripe:{
stripeCompany: domainValues[hostname].stripeCompany,
stripeImage:domainValues[hostname].stripeImage,
stripeKey: domainValues[hostname].stripeKey,
stripeEmail: domainValues[hostname].stripeEmail,
stripeReference: domainValues[hostname].stripeReference,
stripeDesc: domainValues[hostname].stripeDesc,
stripeCurrency: domainValues[hostname].stripeCurrency
},noImages:{
product_thumbnail : domainValues[hostname].product_thumbnail,
product_listing : domainValues[hostname].product_listing,
},
fb: domainValues[hostname].fb,
/* Twitter  */
tw: domainValues[hostname].tw,
/* google Plus data   */
gp: domainValues[hostname].gp,
/* Whatsapp data   */
wa: domainValues[hostname].wa,
site_title: domainValues[hostname].site_title,
site_title_with_separator: domainValues[hostname].site_title_with_separator,
home_meta_title: domainValues[hostname].home_meta_title,
enablescan: (domainValues[hostname].enablesccan !== undefined && domainValues[hostname].enablesccan !== 'No'?"Yes":"No"),

};


/* Chat Widget */
var fileref=document.createElement('script')
fileref.setAttribute("type","text/javascript");
fileref.setAttribute("src", '//keyreply.com/chat/widget.js');
fileref.setAttribute("data-align", "left");
fileref.setAttribute("data-overlay", "false");
fileref.setAttribute("id", "keyreply-script");
fileref.setAttribute("id", "keyreply-script");
fileref.setAttribute("data-color", "#E4392B");
fileref.setAttribute("data-apps", domainValues[hostname].chatWidget);
document.getElementsByTagName("body")[0].appendChild(fileref)

module.exports = getAppValues;
document.body.style.background = 'url('+domainValues[hostname].bgimage+') repeat'
 




// WEBPACK FOOTER //
// ./src/config.js